(ns app.front.view.admin.gis.arcgis-search-config
  "ArcGIS specific search configuration components."
  (:require [app.front.ui :as ui]
            [app.front.ui.select :as ui-select]
            [app.front.util :as futil]
            [app.front.view.admin.gis.common :as gis-common]
            [cljs.pprint]
            [clojure.string :as str]
            [core.front.event :refer [<sub >evt]]
            [core.util.string :as str-util]
            [core.util.util :as util]
            [reagent.core :as r]))

(defn handle-full-url [{:gis-server-config/keys [service-url] :as server-config} set-editor-val url]
  (let [url-suffix                               (str/replace url service-url "")
        [_ folder service service-type layer-id] (re-find #"/?([^/]+)?/([^/]+)/([A-Za-z]+)/?(\d*)$" url-suffix)
        folder                                   (or folder "")
        layer-id                                 (some-> layer-id str-util/blank->nil parse-long)]
    (when service
      (set-editor-val {:gis-service-config/arcgis-folder       folder
                       :gis-service-config/arcgis-service      service
                       :gis-service-config/arcgis-service-type service-type
                       :gis-search-config/arcgis-layer-id      layer-id})
      (>evt [::gis-common/instantly-complete-arcgis-selections server-config folder service service-type layer-id]))))

(defn instant-configure [{:keys [tr server-config search-config-id set-editor-val]}]
  (when-not (gis-common/system-of-type? server-config :azimut-arcgis)
    (r/with-let [*invalid? (r/atom false)]
      (let [server-id (:db/id server-config)
            id        (str/join "-" [server-id search-config-id "instant-config"])
            on-change (fn [v]
                        (if (str/starts-with? v (:gis-server-config/service-url server-config))
                          ;; This is a full URL, try to parse it
                          (do (reset! *invalid? false)
                              (handle-full-url server-config set-editor-val v))
                          (reset! *invalid? true)))]
        [:div.my-4
         [:p.pb-2 (tr [:gis-search-config/manual-url-help-3])]
         [ui/text-input (util/mmap {:on-change  (comp on-change futil/tval)
                                    :label-text (tr [:gis-service-config/arcgis-full-url])
                                    :invalid    @*invalid?
                                    :data-cy    "instant-config-url"}
                                   id)]]))))

(defn folder-selector [{:keys [tr server-config search-config-id selected-folder set-editor-val]}]
  (when-not (gis-common/system-of-type? server-config :azimut-arcgis)
    (let [server-id   (:db/id server-config)
          server-info (<sub [::gis-common/arcgis-server-info server-id])
          folders     (->> server-info
                           keys
                           sort)
          id          (str/join "-" [server-id search-config-id "folder-select"])
          on-change   (fn [v]
                        (if (str/starts-with? v (:gis-server-config/service-url server-config))
                          ;; This is a full URL, try to parse it
                          (handle-full-url server-config set-editor-val v)
                          (do (set-editor-val {:gis-service-config/arcgis-folder       v
                                               :gis-service-config/arcgis-service      nil
                                               :gis-service-config/arcgis-service-type nil
                                               :gis-search-config/arcgis-layer-id      nil})
                              (>evt [::gis-common/fetch-arcgis-server-information
                                     server-config
                                     (str "/" v)
                                     [::gis-common/arcgis-folder-info-fetched server-id v]]))))
          label-text  (tr [:gis-service-config/arcgis-folder])
          value       selected-folder]
      [:div.mt-4
       [:h6.mb-3 (tr [:gis-editor/folder-service-layer])]
       (if (seq folders)
         [ui-select/select (util/mmap
                             {:class-name  "full-width-select"
                              :select-text (tr [:gis-editor/select-folder])
                              :val->str    (fn [v]
                                             (if (str/blank? v)
                                               (tr [:gis-service-config/no-arcgis-folder])
                                               v))
                              :values      folders}
                             id label-text value on-change)]
         [:div
          [:p (tr [:gis-search-config/manual-url-help])
           [:span.font-mono
            (:gis-server-config/service-url server-config)
            [:span.bold (tr [:gis-search-config/manual-url-help-2])]]]
          [ui/text-input (util/mmap {:on-change (comp on-change futil/tval)}
                                    label-text id value)]])])))


(defn service-selector [{:keys [tr server-config search-config-id selected-folder selected-service set-editor-val]}]
  (let [server-id   (:db/id server-config)
        server-info (<sub [::gis-common/arcgis-server-info server-id])
        no-folders? (->> server-info
                         keys
                         (remove str/blank?)
                         empty?)]
    (when (and (or selected-folder no-folders?)
               (not (gis-common/system-of-type? server-config :azimut-arcgis)))
      (let [server-id   (:db/id server-config)
            server-info (<sub [::gis-common/arcgis-server-info server-id])
            services    (when selected-folder
                          (get server-info selected-folder))
            id          (str/join "-" [server-id search-config-id "service-select"])
            label-text  (tr [:gis-service-config/arcgis-service])
            on-change   (fn [{:keys [:gis-service-config/arcgis-service :gis-service-config/arcgis-service-type] :as v}]
                          (set-editor-val {:gis-service-config/arcgis-service      arcgis-service
                                           :gis-service-config/arcgis-service-type arcgis-service-type
                                           :gis-search-config/arcgis-layer-id      nil})
                          (>evt [::gis-common/fetch-arcgis-server-information
                                 server-config
                                 (str/join "/"
                                           [""
                                            selected-folder
                                            arcgis-service
                                            arcgis-service-type])
                                 [::gis-common/arcgis-service-info-fetched server-id selected-folder v]]))
            value       selected-service]
        [:div.mt-3
         (when (seq services)
           [ui-select/select (util/mmap {:class-name   "full-width-select"
                                         :select-text  (tr [:gis-editor/select-service])
                                         :val->str     #(str (:gis-service-config/arcgis-service %)
                                                             " (" (:gis-service-config/arcgis-service-type %) ")")
                                         :allow-empty? false
                                         :values       services}
                                        id label-text on-change value)])]))))


(defn layer-selector [{:keys [tr server-config search-config-id selected-folder selected-service selected-layer-id set-editor-val]}]
  (when selected-service
    (let [server-id  (:db/id server-config)
          id         (str/join "-" [server-id search-config-id "layer-select"])
          layers     (<sub [::gis-common/arcgis-layers server-id selected-folder selected-service])
          on-change  (fn [id]
                       (set-editor-val {:gis-search-config/arcgis-layer-id      id
                                        :gis-search-config/mapping              nil
                                        :gis-search-config/municipality-filters nil})
                       (>evt [::gis-common/fetch-arcgis-server-information
                              server-config
                              (str/join "/"
                                        [""
                                         selected-folder
                                         (:gis-service-config/arcgis-service selected-service)
                                         (:gis-service-config/arcgis-service-type selected-service)
                                         id])
                              [::gis-common/arcgis-layer-info-fetched server-id selected-folder selected-service id]]))
          label-text (tr [:gis-search-config/arcgis-layer-id])
          value      selected-layer-id]
      [:div.mt-3
       (if (seq layers)
         [ui-select/select (util/mmap {:class-name   "full-width-select"
                                       :select-text  (tr [:gis-editor/select-layer])
                                       :val->str     #(as-> (get layers %) layer
                                                            (str (:name layer) " (ID: " % ")"))
                                       :allow-empty? false
                                       :values       (->> (keys layers)
                                                          sort)}
                                      id label-text value on-change)]
         [ui/text-input (util/mmap {:on-change (comp on-change futil/tval)}
                                   id label-text value)])])))
